import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import styles from "./RegistrarCuenta.module.css";
import { useNavigate } from "react-router-dom";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import Loading from "../General/Loading";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import ReCAPTCHA from "react-google-recaptcha";
import { useCallback } from "react";
import { ConsultaWS, ConsultaWSGet } from "../Commons/ServiciosBase";

import BarraLoader from "../General/BarraLoader";

import Modal from "react-bootstrap/Modal";
import Stack from "react-bootstrap/Stack";

import CostumerService from "../Forgot/CostumerService";
import { width } from "@mui/system";
import ConfirmMessage from "../General/ConfirmMessage";

import {
  PreregistrationValidateContract_Request,
  builtPreregistrationValidateContractRequest,
  PreregistrationValidateContract_Parametros,
  PreregistrationValidateContract_Response,
} from "../Commons/Services/izzi/registro/PreregistrationValidateContract";

import {
  AccountPreregistration_Request,
  builtAccountPreregistrationRequest,
  AccountPreregistration_Parametros,
  AccountPreregistration_Response,
} from "../Commons/Services/izzi/registro/AccountPreregistration";

const { REACT_APP_CAPTCHA_KEY } = process.env;

export const RegistrarCuenta = () => {
  const aceptaTerminos = (e: any) => {
    setAcepta(e);
  };

  const [acepta, setAcepta] = useState(false);
  const [validaMailVacio, setValidaMailVacio] = useState(false);
  const [validaPostalCodeVacio, setValidaPostalCodeVacio] = useState(false);
  const [validaMobileVacio, setValidaMobileVacio] = useState(false);
  const [validaAccountVacio, setValidaAccountVacio] = useState(false);
  const [validaAceptaTerminos, setValidaAceptaTerminos] = useState(false);
  const [vMailMessage, setVMailMessage] = useState("");
  const [vMobileMessage, setVMobileMessage] = useState("");
  const [vAccountMessage, setVAccountMessage] = useState("");
  const [vPostalCodeMessage, setVPostalCodeMessage] = useState("");

  const [vAceptaTerminosMessage, setValidaAceptaTerminosMessage] = useState("");
  const [validaCPVacio, setValidaCPVacio] = useState(false);
  const [validaCPFormato, setValidaCPFormato] = useState(false);
  const [vCPMessage, setVCPMessage] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const stylos = {
    borderMail: {
      border: validaMailVacio ? "solid 1px red" : "transparent",
      borderRadius: "2px",
    },
    borderMobile: {
      border: validaMobileVacio ? "solid 1px red" : "transparent",
      borderRadius: "2px",
    },
    borderAccount: {
      border: validaAccountVacio ? "solid 1px red" : "transparent",
      borderRadius: "2px",
    },
  };

  const captchaRef = useRef<ReCAPTCHA>(null);
  const [capchaToken, setCapchaToken] = useState<string>("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const [imagenURI, setImagenURI] = useState(logo);

  const [user, setUser] = useState("");
  const [mobile, setMobile] = useState("");
  const [account, setAccount] = useState("");
  const [disabledInputs, setDisabledInputs] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);

  const [status, setStatus] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, isLoading] = useState(false);
  const [bloqueoBoton, setBloqueoBoton] = useState(false);

  const [typePwd, setTypePwd] = useState("password");

  const handleShowNumber = () =>
    setTypePwd(typePwd === "password" ? "text" : "password");

  const navigate = useNavigate();

  const validarCampo = (e: any, campo: string) => {
    if (campo === "terminos") {
      aceptaTerminos(e);
      if (e === false) {
        setValidaAceptaTerminos(true);
        setValidaAceptaTerminosMessage("Acepta los términos y condiciones");
      } else {
        setValidaAceptaTerminos(false);
      }
    }

    if (campo === "email") {
      setUser(e);
      if (e === "") {
        setValidaMailVacio(false);
        setVMailMessage("El E-mail es requerido");
      } else {
        setValidaMailVacio(false);
      }
    }

    if (campo === "mobile") {
      setMobile(e);
      if (e === "") {
        setValidaMobileVacio(false);
        setVMobileMessage("El teléfono móvil es requerido");
      } else {
        setValidaMobileVacio(false);
      }
    }

    if (campo === "account") {
      setAccount(e);
      if (e === "") {
        setValidaAccountVacio(true);
        setVAccountMessage("El Número de cuenta es requerido");
      } else {
        setValidaAccountVacio(false);
      }
    }

    // Validación del campo Código Postal
    if (campo === "postalCode") {
      setPostalCode(e);
      if (e === "") {
        setValidaCPVacio(true);
        setVCPMessage("El Código Postal es requerido");
      } else if (!/^\d{5,8}$/.test(e)) {
        setValidaCPFormato(true);
        setVCPMessage(
          "El Código Postal debe tener entre 5 y 8 dígitos numéricos"
        );
      } else {
        setValidaCPVacio(false);
        setValidaCPFormato(false);
      }
      let vValue: string = e;
    }
  };

  const handleSubmitRegister = async () => {
    if (
      postalCode == "" ||
      user == "" ||
      account == "" ||
      mobile == "" ||
      acepta == false
    ) {
      if (user == "") {
        setValidaMailVacio(true);
        setVMailMessage("El E-mail es requerido");
      } else {
        setValidaMailVacio(false);
      }

      if (mobile == "") {
        setValidaMobileVacio(true);
        setVMobileMessage("El teléfono móvil es requerido");
      } else {
        setValidaMobileVacio(false);
      }

      if (account == "") {
        setValidaAccountVacio(true);
        setVAccountMessage("El Número de cuenta es requerido");
      } else {
        setValidaAccountVacio(false);
      }

      if (postalCode == "") {
        setValidaPostalCodeVacio(true);
        setVPostalCodeMessage("El Código Postyal es requerido");
      } else {
        setValidaAccountVacio(false);
      }

      if (acepta == false) {
        setValidaAceptaTerminos(true);
        setValidaAceptaTerminosMessage("Acepta los términos y condiciones");
      } else {
        setValidaAceptaTerminos(true);
      }

      return;
    } else {
      /* setStatus({ show: true, color: "red", message: "Validando..." });*/
      isLoading(true);
      doAccountPreregistration();
      //doPreregistrationValidateContract();
    }
  };

  const doPreregistrationValidateContract = async () => {
    isLoading(true);
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      sessionStorage.setItem("cuenta2fa", validarNulosYIndefinidios(account));
      const PreregistrationValidateContractDO =
        builtPreregistrationValidateContractRequest(postalCode, account);
      let par = PreregistrationValidateContract_Parametros(
        PreregistrationValidateContractDO,
        null
      );
      let respuesta: PreregistrationValidateContract_Response =
        await ConsultaWS(par);
      if (respuesta.code === "") {
        //LA VBALIDACION ES CORRECTA SE SIGUE EL FLUJO
        sessionStorage.setItem(
          "emailTOS",
          validarNulosYIndefinidios(respuesta.response.email)
        );
        sessionStorage.setItem(
          "phoneNumberTOS",
          validarNulosYIndefinidios(respuesta.response.phoneNumber)
        );
        setUser(respuesta.response.email);
        setMobile(respuesta.response.phoneNumber);
        isLoading(false);
        setBloqueoBoton(true);

        //doAccountPreregistration();
      } else {
        //LA VBALIDACION ES INCORRECTA HAY QUE AVISASARLE AL USUARIO
        isLoading(false);
        setStatus("ERROR");
        setMessage(respuesta.message);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }

      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const validarNulosYIndefinidios = (param: any) => {
    var retorno: string = "";
    if (param != null && typeof param != "undefined") {
      retorno = param;
    } else {
      retorno = "";
    }

    return retorno;
  };

  const doAccountPreregistration = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const AccountPreregistrationRequest: AccountPreregistration_Request =
        builtAccountPreregistrationRequest(
          user,
          account,
          postalCode,
          "temporary123"
        );
      let par = AccountPreregistration_Parametros(
        AccountPreregistrationRequest,
        null
      );
      let respuesta: AccountPreregistration_Response = await ConsultaWS(par);
      if (respuesta.message === "OK") {
        //LA VBALIDACION ES CORRECTA SE SIGUE EL FLUJO
        //SE REDIRECCIONA A LA PANTALLA DE INGRESAR TOKEN
        redirect("/registrar2f");
      } else {
        //LA VBALIDACION ES INCORRECTA HAY QUE AVISASARLE AL USUARIO
        setStatus("ERROR");
        setMessage("Error al pre registrar la cuenta");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }
      isLoading(false);
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  function redirect(url: string) {
    var ua = navigator.userAgent.toLowerCase(),
      isIE = ua.indexOf("msie") !== -1,
      version = parseInt(ua.substr(4, 2), 10);

    // Internet Explorer 8 and lower
    if (isIE && version < 9) {
      var link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
    }

    // All other browsers can use the standard window.location.href (they don't lose HTTP_REFERER like Internet Explorer 8 & lower does)
    else {
      window.location.href = url;
    }
  }

  const handleRecaptcha = useCallback((token: string | null) => {
    setCapchaToken(token || "");
  }, []);

  return (
    <>
      <Container className={styles.container}>
        <div className={styles["confirmMessage"]}>
          <ConfirmMessage
            status={status}
            message={message}
            showAlert={showAlert}
          />
        </div>
        <Loading isLoading={loading} />
        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["registrarForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} />
              <hr className={styles["line"]} />

              <Row>
                <h4
                  className={
                    "text-2xl text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  <span>Registrate en MiSky</span>
                </h4>
              </Row>

              <Form.Group
                className={styles.label + " mb-0"}
                controlId="formBasicCuenta"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  Ingresa número de cuenta
                </Form.Label>

                <Form.Control
                  value={account}
                  onBlur={(e) => validarCampo(e.target.value, "account")}
                  onChange={(e) => validarCampo(e.target.value, "account")}
                />
                {validaAccountVacio ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vAccountMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Form.Group>

              <Row className="align-items-end">
                <Col md={8}>
                  <Form.Group
                    className={styles.label + " mb-3"}
                    controlId="formBasicPostalCode"
                  >
                    <Form.Label className={styles.estiloLabels}>
                      Código Postal
                    </Form.Label>
                    <Form.Control
                      value={postalCode}
                      onChange={(e) =>
                        validarCampo(e.target.value, "postalCode")
                      }
                    />
                    {(validaCPVacio || validaCPFormato) && (
                      <Form.Label>
                        <span
                          className={styles.estiloLabels + " " + styles.mensaje}
                        >
                          {vCPMessage}
                        </span>
                      </Form.Label>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4} className="text-end">
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    disabled={bloqueoBoton}
                    onClick={doPreregistrationValidateContract}
                  >
                    Validar
                  </Button>
                </Col>
              </Row>

              <Form.Group
                className={styles.label + " mb-0"}
                controlId="formBasicEmail"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  E-mail
                </Form.Label>

                <Form.Control
                  type="email"
                  onBlur={(e) => validarCampo(e.target.value, "email")}
                  onChange={(e) => validarCampo(e.target.value, "email")}
                  value={user}
                  disabled={disabledInputs}
                  readOnly
                  className={styles.readOnlyField} // Aplica la clase para el efecto visual
                />
                {validaMailVacio ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vMailMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Form.Group>

              <Form.Group
                className={styles.label + " mb-0"}
                controlId="formBasicMobile"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  Número de teléfono móvil
                </Form.Label>

                <Form.Control
                  onBlur={(e) => validarCampo(e.target.value, "mobile")}
                  onChange={(e) => validarCampo(e.target.value, "mobile")}
                  value={mobile}
                  disabled={disabledInputs}
                  readOnly
                  className={styles.readOnlyField} // Aplica la clase para el efecto visual
                />
                {validaMobileVacio ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vMobileMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Form.Group>

              <div className="flex flex-col justify-center">
                {process.env.REACT_APP_CAPTCHA_KEY && (
                  <ReCAPTCHA
                    ref={captchaRef}
                    type="image"
                    sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                    onChange={handleRecaptcha}
                  />
                )}
                {/*onChange={(value) => setValue('captcha', value)} */}
                {/*errors.captcha?.message && <p className='text-sm font-light mb-2 text-[#ef4444]'>{errors.captcha.message}</p>*/}
              </div>

              <Row style={{ marginTop: "1vw" }}>
                <Col lg={1} xl={1} md={1} sm={1} xs={1}>
                  <Form.Check
                    type="checkbox"
                    checked={acepta}
                    onBlur={(e) => validarCampo(e.target.checked, "terminos")}
                    onChange={(e) => validarCampo(e.target.checked, "terminos")}
                  />
                </Col>
                <Col lg={11} xl={11} md={11} sm={11} xs={11}>
                  <span>He leído y acepto los términos de </span>
                  <a
                    href="https://www.sky.com.mx/avisoprivacidad"
                    className={styles.link}
                  >
                    aviso de privacidad
                  </a>{" "}
                  <span> y del</span>
                  <a
                    href="https://www.sky.com.mx/avisoprivacidad"
                    className={styles.link}
                  >
                    convenio de uso
                  </a>
                  <span> para continuar</span>
                </Col>

                {validaAceptaTerminos ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vAceptaTerminosMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Row>

              <Row>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    onClick={handleSubmitRegister}
                    disabled={
                      postalCode == "" &&
                      user == "" &&
                      account == "" &&
                      mobile == "" &&
                      acepta == false
                    }
                  >
                    Registrarse
                  </Button>
                </Col>
              </Row>

              <>
                <Row>
                  <Col className="center text-center">
                    <span className="center">¿Ya tienes cuenta?</span>{" "}
                    <a
                      onClick={() => navigate("/login")}
                      className={styles["login"]}
                    >
                      <span className="text-end">Inicia sesión</span>
                    </a>
                  </Col>
                </Row>
              </>
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} />
          </Col>
        </Row>
      </Container>

      <Modal
        className={styles.contenedorModal}
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {" "}
        <Modal.Header className="border-0" closeButton></Modal.Header>{" "}
        <Modal.Body>
          <CostumerService />{" "}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RegistrarCuenta;
